import { useEffect, useRef, useState } from "react";

const useIntersectionObserver = () => {
  const [isInView, setIsInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.unobserve(currentRef);
        }
      },
      { root: null, rootMargin: "0px", threshold: 0.15 }
    );

    observer.observe(currentRef);
    return () => observer.unobserve(currentRef);
  }, []);

  return [ref, isInView];
};

export default useIntersectionObserver;
